import FilterList from './filter-list';

export default FilterList;